import React from "react";
import PageShell from "@/components/PageShell";
import Hero from "@/components/home/Hero";
import ObservationCarousel from "@/components/home/ObservationCarousel";
import FieldNotesStrip from "@/components/home/FieldNotesStrip";
import AreasOfStudy from "@/components/home/AreasOfStudy";
import BuildingPreview from "@/components/home/BuildingPreview";
import PhilosophyPreview from "@/components/home/PhilosophyPreview";
import SelectedThinking from "@/components/home/SelectedThinking";
import ArtifactsAcknowledgementsPreview from "@/components/home/ArtifactsAcknowledgementsPreview";
import ArchiveNow from "@/components/home/ArchiveNow";
import ContactInvitation from "@/components/home/ContactInvitation";
import NextRoom from "@/components/NextRoom";

export default function Home() {
  return (
    <PageShell
      testId="page-home"
      title="Quentin Young | Canadian Entrepreneur, Founder & Strategic Operator"
      description="QuentinYoung.ca is the official site of Quentin Young: Canadian entrepreneur, founder, operator, brand strategist, and creative leader exploring human nature, culture, systems, leadership, craft, and the conditions that shape individual and collective potential."
      ogImage="/og-image.jpg"
    >
      <Hero />
      <ObservationCarousel />
      <FieldNotesStrip />
      <AreasOfStudy />
      <BuildingPreview />
      <PhilosophyPreview />
      <SelectedThinking />
      <ArtifactsAcknowledgementsPreview />
      <ArchiveNow />
      <NextRoom
        eyebrow="Where to begin"
        title="Three doors. Any of them lead deeper."
        rooms={[
          { label: "Begin with the observations", to: "/thinking", hint: "thinking" },
          { label: "See what is being built", to: "/building", hint: "proof" },
          { label: "How Quentin came to see it this way", to: "/about", hint: "origin" },
        ]}
        testId="home-next"
      />
      <ContactInvitation />
    </PageShell>
  );
}
